// import ChatTime from '../atoms/chatTime'
import ChatMessage from '../atoms/chatMessage'
import ChatAvatar from '../atoms/chatAvatar'

const ChatBubble = ({ msg, user, avatar, time }) => {
  let avatarDefault = 'https://ui-avatars.com/api/?color=ffffff&background=1687a7&uppercase=false&length=1&name='+ user
  return (
    <div id="chatBubble" className="p-3.5 rounded-xl bg-bg mb-6 w-fit max-w-[54vw]">
      <div className="flex justify-between items-center mb-3">
        {
          avatar 
          ? <ChatAvatar username={user} avatar={avatar} /> 
          : <ChatAvatar username={user} avatar={avatarDefault} />
        }
        {/* <ChatTime time={time} /> */}
      </div>
      <ChatMessage msg={msg} />
    </div>
  )
}

export default ChatBubble
